import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import AddToWishlist from '../common/AddToWishlist';
import PLPWishlistMobile from '../common/PLPWishlistMobile';
import PLPSwatches from '../common/PLPSwatches';
import styles from "../PlpWishlistComp/WishlistPlpOptions.module.scss";
import { handleize } from '@/helpers/userHelpers';
import { hasCookie, getCookie, deleteCookie } from 'cookies-next';
import useOutsideClick from '@/helpers/hooks/useOutsideClick';
import FavouriteIcon from "@/components/common/FavouriteIcon";
import {setPLPWishlistClicked} from '@/redux/actions/generalAction'
import { useRouter } from 'next/compat/router';

const PlpWishlistComp = (props) => {
  const { productDetails } = props;
  const [fav, setFav] = useState(false);
  const [showWishList, setShowWishList] = useState(false);
  const [options, setOptions] = useState(false);
  const [optionName, setOptionName] = useState(false);
  const [openOptions, setOpenOptions] = useState(false);
  const [optionArray, setOptionArray] = useState();
  const [singleVariant, setSingleVariant] = useState(false);
  const [currentVariant, setCurrentVariant] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [hexValue, setHexValue] = useState([]);
  const [loading, setLoading] = useState(false);
  const wishlistItems = useSelector((state) => state.wishlist.wishlist);
  const userId = useSelector((state) => state.loginUser.userData?.id);
  const wishlistHash = useSelector((state) => state.wishlist.wishlistHashId);
  const dispatch = useDispatch();
  const router = useRouter();
  /* Use effects */
  const wishListRef = useRef(null);
  useOutsideClick(wishListRef, () => {
    if (!props.isOnlyMobile) {
      setOpenOptions(false);
      setShowOptions(false);
    }
  })
  useEffect(() => {
    drawOptions();
    if (showOptions) {
      dispatch(setPLPWishlistClicked(true))
    }
    else {
      dispatch(setPLPWishlistClicked(false))
    }
  }, [showOptions]);

  //sign in on wishlist click from product carousel
  useEffect(() => {
    if (wishlistHash) {
      checkCookie();
    }
  }, [wishlistHash]);

  useEffect(() => {
    setUpFav();
  }, [wishlistItems]);
  const checkCookie = () => {
    if (hasCookie('isFavourite')) {
      let cookieData;
      try {
        cookieData = JSON.parse(getCookie("isFavourite"));
      }
      catch (e) {
        console.error("Wishlist cookie data format error", e);
      }
      if (cookieData) {
        if (cookieData?.product?.id === productDetails.id) {
          let thisCurrentV = productDetails?.variants?.edges?.find(variant => {
            variant = variant.node;
            return variant.id === cookieData.fullVariant.id
          })
          if (thisCurrentV?.node) {
            deleteCookie("isFavourite");
            fireWishlistActionForSingle(thisCurrentV.node);
          }
        }
      }
    }
  }
  const drawOptions = () => {
    /* Check single or multiple options */
    let obj = {};
    let thisOptionArray = [];
    productDetails?.options?.forEach(option => {
      if (option.values.length > 1) {
        obj.name = option.name;
        obj.values = option.values;
      }
    });
    if (!obj.values) {
      /* If single option */
      setSingleVariant(true);
      let currentV = productDetails?.variants?.edges[0]?.node;
      if (currentV) {
        setCurrentVariant(currentV);
      }
      else {
        console.error("Current variant not set for the single variant", productDetails);
      }
    }
    else {
      /* Multiple options */
      let availableVariants = {};
      let hexArray = [];
      /* Creating an object like {8US:variantObj,10US:variantObj} */
      productDetails?.variants?.edges?.forEach(variant => {
        variant = variant.node;
        /* Remove the soldout variants */
        // if (!variant.availableForSale) {
        //   return false;
        // }

        variant.selectedOptions.forEach(option => {
//SUP-3909 to not allow listing of duplicate entries check is done
          if (option.name === obj.name && !thisOptionArray?.includes(option?.value)) {
            availableVariants[option.value] = variant;
            thisOptionArray.push(option.value);
            if (option.name === 'Color') {
              let thisHexValue = variant?.hexColor?.value;
              if (thisHexValue) {
                hexArray.push([thisHexValue])
              }
            }
          }

        })
        return false;
      })
      setOptions(availableVariants);
      setOptionArray(thisOptionArray);
      setOptionName(obj.name);
      setHexValue(hexArray)
    }
  }
  const setUpFav = () => {
    /* If product is in wishlist Already */
    let pid = productDetails.id.split("/");
    pid = pid[pid.length - 1];
    let foundWish = wishlistItems?.find(item => {
      return item.ProductId === pid
    })
    if (foundWish) {
      /* after finding the wishlist product setup the current variant and wishlist state (fav) */
      let cVariant = productDetails.variants.edges.find(item => {
        item = item.node;
        let vid = item.id.split('/');
        vid = vid[vid.length - 1];
        return vid === foundWish.ProductVariantId
      });
      
      if (cVariant && cVariant.node) {
        setFav(true);
        setCurrentVariant(cVariant.node);
      }
    }
    else {
      setFav(false);
    }
  }
  const afterAddToWishlist = () => {
    /* After product added in wishlist */
    setFav(true); // set fav
    setShowWishList(false); // remove the wish comp
    document.querySelector("body").classList.remove("disable-scroll");
    setOpenOptions(false); // remove the option comp
    setLoading(false);
    setTimeout(() => {
      setShowOptions(false);
    }, 300);
    //close the wishlist popup
  }
  const afterRemoveWishlist = () => {
    /* After product removed from wishlist */
    setFav(false);// unset fav
    setShowWishList(false); // remove the wish comp
    setOpenOptions(false);// remove the option comp
    setLoading(false);
    setTimeout(() => {
      setShowOptions(false);
    }, 300);
    //close the wishlist popup
  }
  const fireWishlistAction = (optionVal) => {
    let thisCurrentVariant = options[optionVal];
    /* Add to wishlist action. Only for multi option products */
    if (!thisCurrentVariant) {
      return;
    }
    setCurrentVariant(thisCurrentVariant);
    setLoading(true);
    setShowWishList(true);
  }
  const fireWishlistActionForSingle = (variant) => {
    /* Add to wishlist action. Only for Single variant */
    if (!variant) {
      return;
    }
    setCurrentVariant(variant);
    setLoading(true);
    setShowWishList(true);
  }
  const handleClickEvent = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!e.target.parentNode.classList.contains('wish-wrapper')) {
      return
    }
    if (fav) {
      /* to remove product from wishlist */
      setShowWishList(true);
      //setLoading(true)
    } else {
      setShowOptions(true);  //for showing variant options
      if (options) {
        /* For multi-options product, open the option drawer */
        setOpenOptions(true);
      } else {
        /* For single variant direct add to wishlist */
        setShowWishList(true);
        setLoading(true);
      }
    }
  }
  const handleTabIndex = (e) => {
    if(e.key=='Enter'){
      if (fav) {
        /* to remove product from wishlist */
        setShowWishList(true);
      }
      else {
        setShowOptions(true);  //for showing variant options
        if (options) {
          /* For multi-options product, open the option drawer */
          setOpenOptions(true);
        } else {
          /* For single variant direct add to wishlist */
          setShowWishList(true);
          setLoading(true);
        }
      }
    }
  }
  //On mouse enter hover show wishlist options
  const handleMouseHoverEvent = (e) => {
    //if fav do nothing and return else show options
    if (fav) {
      return;
    }
    else {
      setShowOptions(true);  //for showing variant options
      if (options) {
        /* For multi-options product, open the option drawer */
        setOpenOptions(true);
      } else {
        /* For single variant direct add to wishlist */
        //setShowWishList(true);
        setLoading(true);
      }
    }
  }
  if (!options && !singleVariant) {
    /* Don't render anything until Single variant or Variant options are not found */
    return null
  }
  return (
    <>
      {/* hover only on multiple variants */}
      {!props.isOnlyMobile && <div className={`plp_wishlist ${styles.plp_wishlist} ${singleVariant != true && showOptions ? `opened-w ${styles.opened}` : ''} ${singleVariant == true ? 'hide-options' : ''}`} onMouseLeave={() => setShowOptions(false)} onMouseEnter={(e) => singleVariant ? "" : handleMouseHoverEvent(e)} onClick={(e) => {
        e.preventDefault();
      }}
      >
        <div
          className={`wish-wrapper ${fav ? "active" : ""} ${styles.fav} ${!fav && router.asPath.includes("/wishlist/")&& "ga-wishlist-plp"}`}
          onClick={handleClickEvent}
          ref={wishListRef}
          id={`favorite-${productDetails.id}`}
          tabIndex={0}
          onKeyDown={(e)=>{handleTabIndex(e)}}
        >
          <FavouriteIcon
            isFilled={fav}
            height={10}
            width={11}
            className={`${!fav && router.asPath.includes("/wishlist/")&& "ga-wishlist-plp"} `}
          />
          {openOptions ?

            <>
              {/* Product variant options */}
              <PLPSwatches
                data={optionArray}
                link={`${process.env.NETLIFY_URL}/products/${productDetails.handle}`}
                type={handleize(optionName)}
                handle={productDetails.handle + "wish"}
                wishlistComp={true}
                fireWishlistAction={fireWishlistAction}
                hexCodeArray={hexValue}
                setLoading={setLoading}
                loading={loading}
                searchPopupEnabled={props.searchComp}
              />
            </>
            : <FavouriteIcon
              isFilled={false}
              height={10}
              width={11}
              className={`${!fav && router.asPath.includes("/wishlist/")&& "ga-wishlist-plp"} `}
            />}
        </div>
      </div>}
      {/* To hide wishlist on mobile product tiles  d-none class is added */}
      {props.isOnlyMobile && <div className={`plp_wishlist d-none ${styles.plp_wishlist} hide-options ${showOptions ? styles.plpWishlist_open : ""} `} onClick={handleClickEvent} >
        <div
          className={`wish-wrapper ${fav ? "active" : ""} ${styles.fav} ${!fav && router.asPath.includes("/wishlist/")&& "ga-wishlist-plp"} `}
          ref={wishListRef}
          id={`favorite-${productDetails.id}`}
        >
          <FavouriteIcon
            isFilled={fav}
            height={9}
            width={9.82}
            className={`${!fav && router.asPath.includes("/wishlist/")&& "ga-wishlist-plp"} `}
          />
          {openOptions ?
            <>
              {/* Product variant options */}
              <PLPWishlistMobile
                data={optionArray}
                link={`${process.env.NETLIFY_URL}/products/${productDetails.handle}`}
                type={handleize(optionName)}
                handle={productDetails.handle + "wish"}
                openOptions={openOptions}
                fireWishlistAction={fireWishlistAction}
                hexCodeArray={hexValue}
                productDetails={productDetails}
                dropdownTitle={handleize(optionName)}
                productImage={props.product.product_image}
                setOpenOptions={setOpenOptions}
                optionName={optionName}
                wishlistComp={true}
              />
            </>
            : <FavouriteIcon
              isFilled={false}
              height={9}
              width={9.82}
              className={`${!fav && router.asPath.includes("/wishlist/")&& "ga-wishlist-plp"} `}
            />}
        </div>
      </div>}

      {/* For adding and removing wishlist */}
      {showWishList && <>
        <div className="d-none"> <AddToWishlist
          selectedVariant={currentVariant}
          product={productDetails}
          favouriteIconHeight={20}
          favouriteIconWidth={20}
          autoAdd={true}
          isSizeSelected={true}
          wishListCallBack={fav ? afterRemoveWishlist : afterAddToWishlist}
          autoRemove={fav}
        /> </div>
      </>}
    </>
  )
}

export default PlpWishlistComp;